/** Sérialise les mutations IMAP lourdes (delete/move bulk) — une à la fois. */
let chain = Promise.resolve();

export function enqueueMailMutation<T>(fn: () => Promise<T>): Promise<T> {
  const next = chain.then(fn, fn);
  chain = next.then(
    () => undefined,
    () => undefined
  );
  return next;
}
